<!-- Full page loader overlay -->
<div class="loading-overlay" *ngIf="isExportingPatients">
    <div class="loading-spinner">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div class="loading-text">{{ exportLoadingMessage }}</div>
</div>

<mat-toolbar color="primary" class="action-toolbar">
    <h3>Patient List</h3>
    <button mat-icon-button *ngIf="allowExportPatients"
        (click)="exportPatients()" matTooltip="Export All Patients to Excel" [disabled]="isExportingPatients">
        <mat-icon>{{ isExportingPatients ? 'hourglass_empty' : 'file_download' }}</mat-icon>
    </button>
    <button mat-icon-button *ngIf="isDoctor && isClinicalPatientListTab"
        (click)="addPatient('',true)" matTooltip="Express Add New Patient"><mat-icon
            class="bolt-icon">bolt</mat-icon></button>
    <button mat-icon-button *ngIf="allowAddPatient" (click)="addPatient()"
        matTooltip="Add New Patient"><mat-icon color="primary">add</mat-icon></button>
</mat-toolbar>

<div class="list-container">
    <div class="filter-wrapper">
        <mat-form-field appearance="outline" class="filter-field">
            <mat-label>Search</mat-label>
            <input matInput [(ngModel)]="filterValue" (keyup)="applyFilter($event)" placeholder="Search patients"
                #input>
            <mat-icon matSuffix *ngIf="!filterValue">search</mat-icon>
            <mat-icon matSuffix *ngIf="filterValue" (click)="filterValue = ''" class="clickable">close</mat-icon>
            <!-- <button mat-icon-button matSuffix type="button" [matMenuTriggerFor]="sortMenu" matTooltip="Sort list"
                aria-label="Sort list">
                <mat-icon>sort</mat-icon>
            </button> -->
            <mat-icon matSuffix [matMenuTriggerFor]="sortMenu" matTooltip="Sort list"
                aria-label="Sort list" class="clickable">sort</mat-icon>
            <mat-menu #sortMenu="matMenu" xPosition="before">
                <button mat-menu-item (click)="setSort('surname', 'asc')">
                    <mat-icon *ngIf="sortBy === 'surname' && sortDirection === 'asc'">check</mat-icon>
                    <span>Surname (A→Z)</span>
                </button>
                <button mat-menu-item (click)="setSort('surname', 'desc')">
                    <mat-icon *ngIf="sortBy === 'surname' && sortDirection === 'desc'">check</mat-icon>
                    <span>Surname (Z→A)</span>
                </button>
                <button mat-menu-item (click)="setSort('firstName', 'asc')">
                    <mat-icon *ngIf="sortBy === 'firstName' && sortDirection === 'asc'">check</mat-icon>
                    <span>First name (A→Z)</span>
                </button>
                <button mat-menu-item (click)="setSort('firstName', 'desc')">
                    <mat-icon *ngIf="sortBy === 'firstName' && sortDirection === 'desc'">check</mat-icon>
                    <span>First name (Z→A)</span>
                </button>
                <button mat-menu-item (click)="setSort('patientNumber', 'asc')">
                    <mat-icon *ngIf="sortBy === 'patientNumber' && sortDirection === 'asc'">check</mat-icon>
                    <span>Patient number (A→Z)</span>
                </button>
                <button mat-menu-item (click)="setSort('patientNumber', 'desc')">
                    <mat-icon *ngIf="sortBy === 'patientNumber' && sortDirection === 'desc'">check</mat-icon>
                    <span>Patient number (Z→A)</span>
                </button>
            </mat-menu>
            <mat-hint>Search by name, surname, patient number, or diagnosis</mat-hint>
        </mat-form-field>
    </div>
    <!-- Each tab's list is built the first time it is opened and then kept, so closed tabs cost nothing at login -->
    <mat-tab-group (selectedIndexChange)="onTabChange($event)" [selectedIndex]="selectedTabId" class="tab-group"
        matTabGroupGesture [swipeLimitWidth]="80" [connectEdges]="true" [preserveContent]="true">

        <!-- Tabs and their order come from visibleTabs (see PatientListComponent) -->
        <mat-tab *ngFor="let tab of visibleTabs; trackBy: trackByTabKey">
            <ng-template mat-tab-label>
                {{ tab.label }} ({{ tab.count }})
            </ng-template>
            <ng-template matTabContent>
            <div class="tab-content" [ngSwitch]="tab.key">
                <app-outpatient-list *ngSwitchCase="'opd'" [filterValue]="filterValue" [sortBy]="sortBy"
                    [sortDirection]="sortDirection"></app-outpatient-list>
                <app-inpatient-list *ngSwitchCase="'inpatient'" [filterValue]="filterValue" [sortBy]="sortBy"
                    [sortDirection]="sortDirection" id="inpatient-content"></app-inpatient-list>
                <app-invite-list *ngSwitchCase="'invite'" [filterValue]="filterValue" [sortBy]="sortBy"
                    [sortDirection]="sortDirection"></app-invite-list>
                <app-file-alert-list *ngSwitchCase="'alert'" [filterValue]="filterValue" [sortBy]="sortBy"
                    [sortDirection]="sortDirection"></app-file-alert-list>
                <app-duplicate-alert-list *ngSwitchCase="'duplicate'" [filterValue]="filterValue" [sortBy]="sortBy"
                    [sortDirection]="sortDirection"></app-duplicate-alert-list>
                <app-deceased-list *ngSwitchCase="'deceased'" [filterValue]="filterValue" [sortBy]="sortBy"
                    [sortDirection]="sortDirection"></app-deceased-list>
                <app-archive-list *ngSwitchCase="'archive'" [filterValue]="filterValue" [sortBy]="sortBy"
                    [sortDirection]="sortDirection"></app-archive-list>
            </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>


</div>